/* eslint-disable */
import axios from "axios";
import OktaAuthRef from "../../../auth/okta";
import HttpCode from "../configs/http-codes";

// Define general configs
const axiosConfig = {
  baseURL: process.env.VUE_APP_AZURE_POSCOM_BASE_URL,
  timeout: 150000
};

// Http client for public requests (Without any token)
const PublicHttpClient = axios.create(axiosConfig);

// Http client for protected requests (With token)
const ProtectedHttpClient = axios.create(axiosConfig);

// Prepare Request Intercepts
// eslint-disable-next-line @typescript-eslint/no-explicit-any
ProtectedHttpClient.interceptors.request.use(config => {
  config.params = config.params || {};
  config.params.code = process.env.VUE_APP_AZURE_POSCOM_CODE;
  config.params.clientId = process.env.VUE_APP_AZURE_POSCOM_CLIENT_ID;
  const idToken = OktaAuthRef.getIdToken();
  config.headers.Authorization = `Bearer ${idToken}`;
  return config;
});

// Prepare response interceptors to handle errors
ProtectedHttpClient.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === HttpCode.UNAUTHORIZED) {
      //   window.location.href = PAGE_LINKS.login.url;
    }
  }
);

const HttpClient = {
  ProtectedHttpClient,
  PublicHttpClient
};

export default HttpClient;
